var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AutoComplete',{attrs:{"data":_vm.fileList,"filter-method":_vm.filterMethod,"placeholder":_vm.placeholder,"size":_vm.size,"disabled":_vm.disabled},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }